<app-header></app-header>
<div class="vincent_about1">
    
    <div class=" vincent_title_block vincent_corners">
        <div class="vincent_inner_text">
            <h1>{{"about" | translate}}</h1>
        </div>
    </div>

<div class="row">
    <div class="col col-12 vincent_content">

        <div class="vincent_container vincent_content_title_block" style="padding-top:100px; text-align: center;">
            <h2>{{"lorem" | translate}}</h2>
            <h6> {{"short_lorem" | translate}}</h6>
            <img src="assets/imgs/separator_light.png">

            <div *ngFor="let info of about;">
                 <p *ngIf="about_en == true">{{info.description}}</p>
                 <p *ngIf="about_ar == true">{{info.description_ar}}</p>
            </div>

            <a class="vincent_button vincent_button_background" routerLink="/menu">
                <i class="fa fa-angle-left" aria-hidden="true" style="position: relative; right: 9px;"></i>
                {{"show_menu" | translate}}
            </a>
        </div>


        <div class="vincent_container vincent_team">
            <h2>{{"crew" | translate}}</h2>
            <div class="row gutters">
                <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12 col-12" *ngFor="let info of crews;">
                    <div class="vincent_team_item">
                        <div class="vincent_team_image" style="text-align: center;">
                            <img [src]="info.photoUrl" class="crew-avatar">
                        </div>
                        <div class="vincent_team_description">
                            <h5 *ngIf="name_en == true">{{info.name}}</h5>
                            <h5 *ngIf="name_ar == true">{{info.name_ar}}</h5>
                            <p *ngIf="job_en == true">{{info.job}} </p>
                            <p *ngIf="job_ar == true">{{info.job_ar}} </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
       
        <app-features></app-features>

    </div>
</div>

<app-footer></app-footer>